module.exports = __webpack_public_path__ + "img/external-link-alt.ed77638f.svg";